export const getTicks = (number) => {
  if (number === 0) {
    return { max: 100, stepSize: 25 }
  } else {
    // // 자릿수
    // let digit = String(Math.ceil(number)).length - 1

    // // 맥스
    // let max = Math.ceil(number / Math.pow(10, digit)) * Math.pow(10, digit)

    // console.log('$$ max', number)

    // 맥스 조정(4의 배수 값)
    let fourMax = 4 * Math.ceil(number / 4)
    // let fourMax = max + (max % 4)

    // 최종 맥스가 12 미만이면 강제로 14로 조정
    // + 최종 맥스가 4 이하이면 강제로 4로 조정(fourMax가 6으로 조정된 값)
    // 소수점으로 안나오게 하기 위함

    // if (fourMax <= 6) {
    //   fourMax = 4
    // }

    // if (fourMax > 6 && fourMax < 12) {
    //   fourMax = 12
    // }

    return {
      // 2
      max: fourMax,
      stepSize: fourMax / 4,

      // 1
      // max: fourMax < 12 ? 12 : fourMax,
      // stepSize: fourMax < 12 ? 3 : fourMax / 4,
    }
  }
}
